import { Box, styled } from '@mui/material';
import { spaceCadet } from '../../utils/colors';

const StyledBox = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  marginTop: 50,
  maxWidth: 'unset',
  '& .logo': {
    width: 64,
  },
  '& .MuiTypography-h1': {
    fontSize: 32,
    fontWeight: 600,
    marginTop: 10,
    color: spaceCadet[700],
  },
});

export default StyledBox;
